import { useMemo } from "react";
import {
  Item,
  ItemNoAndTypeWithPieces,
  ItemWithPieces,
} from "@coworker/apprestructured/src/shared/types/item";
import { isLoading, LOADING, Loading } from "../loading";

const NO_ITEMS_WITH_PIECES: ItemWithPieces[] = [];

export const useItemsWithPieces = (
  items: Item[],
  itemNosAndTypeWithPieces?: ItemNoAndTypeWithPieces[] | null | Loading
): ItemWithPieces[] => {
  return useMemo(() => {
    if (isLoading(itemNosAndTypeWithPieces)) {
      return NO_ITEMS_WITH_PIECES;
    }
    const selectedItems = Array.isArray(itemNosAndTypeWithPieces)
      ? itemNosAndTypeWithPieces
      : NO_ITEMS_WITH_PIECES;

    const piecesByItemNo = new Map(
      selectedItems.map(({ no, pieces }) => [no, pieces ?? 0])
    );

    return items.map((item) => ({
      ...item,
      pieces: piecesByItemNo.get(item.no) ?? 0,
    }));
  }, [items, itemNosAndTypeWithPieces]);
};
